import type { RegistrationEntrantSummary } from '../types';

/**
 * Build the checkout-step entrant summary from the authenticated session on a
 * resume path, where the interactive auth step never mounts to populate
 * `auth.entrant`.
 *
 * The session splits the fields across two payloads: `authMe.entrant` carries
 * id/firstName/lastName but NO email, while the email lives on `authMe.user`.
 * Combining them here keeps that gotcha in one tested place.
 *
 * Returns `null` unless both are present (i.e. an authenticated entrant).
 */
export function buildResumeEntrantSummary(
  entrant: { id: string; firstName: string; lastName: string } | null,
  user: { email: string } | null,
): RegistrationEntrantSummary | null {
  if (!entrant || !user) return null;
  return {
    id: entrant.id,
    email: user.email,
    firstName: entrant.firstName,
    lastName: entrant.lastName,
  };
}
